import { ChangeEvent } from 'react';

export function createInputChangeHandler(rawValueHandler: (value: string) => void) {
  return (event: ChangeEvent<EventTarget>) => {
    rawValueHandler((event.currentTarget as HTMLInputElement).value);
  };
}

export function getKeyboardEventCode(event: KeyboardEvent): string {
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  const code = (event as any).code || event.key || (event as any).keyIdentifier;

  return code;
}

export function getKeyPressed(event: KeyboardEvent): string {
  const letter =
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    (event as any).key || String.fromCharCode(parseInt((event as any).keyIdentifier.replace('U+', ''), 16));

  return /^[\wа-яА-ЯЁё]$/.test(letter) ? letter : undefined;
}

export function on(el: HTMLElement | Window, eventName: string, callback: () => void) {
  if (el && el.addEventListener) {
    el.addEventListener(eventName, callback, false);
  }
}

export function off(el: HTMLElement | Window, eventName: string, callback: () => void) {
  if (el && el.removeEventListener) {
    el.removeEventListener(eventName, callback);
  }
}
